import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { InputLabeledContainer, TextArea, TextInput } from 'tennders-common/form/components'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'

const FullAddress = (props) => {
  const { t } = useTranslation()
  const {
    form,
    errors,
    onChange,
    disabled = false
  } = props

  return (
    <>
      <InputLabeledContainer
        name="companyAddress"
        className="mb-24"
        form={form}
        errors={errors}
        label={t('document:fullAddress')}
        onChange={onChange}
        required
        renderInput={(rest) => (
          <TextArea
            placeholder={t('addBranch:full_company_add')}
            {...rest}
            disabled={disabled}
          />
        )}
      />
      <div className="d-flex">
        <InputLabeledContainer
          name="companyNif"
          label={t('document:vatCode')}
          className="mr-16"
          form={form}
          errors={errors}
          onChange={onChange}
          required
          disabled={(form?.companyName && form?.companyNif) || disabled}
          renderInput={(rest) => (
            <TextInput
              maxLength={INPUT_CHARACTER_LIMITS.VAT_ID}
              {...rest}
            />
          )}
        />
      </div>
    </>
  )
}

export default React.memo(FullAddress)
